var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 8.13401 8.13401 5 12 5H30C33.866 5 37 8.13401 37 12V30C37 33.866 33.866 37 30 37H12C8.13401 37 5 33.866 5 30V12Z",
    fill: "#618DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 43C8.13401 43 5 46.134 5 50V68C5 71.866 8.13401 75 12 75H30C33.866 75 37 71.866 37 68V50C37 46.134 33.866 43 30 43H12ZM11 50C11 49.4477 11.4477 49 12 49H30C30.5523 49 31 49.4477 31 50V68C31 68.5523 30.5523 69 30 69H12C11.4477 69 11 68.5523 11 68V50Z",
    fill: "#618DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 12C43 8.13401 46.134 5 50 5H68C71.866 5 75 8.13401 75 12V30C75 33.866 71.866 37 68 37H50C46.134 37 43 33.866 43 30V12ZM50 11C49.4477 11 49 11.4477 49 12V30C49 30.5523 49.4477 31 50 31H68C68.5523 31 69 30.5523 69 30V12C69 11.4477 68.5523 11 68 11H50Z",
    fill: "#618DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 43C46.134 43 43 46.134 43 50V68C43 71.866 46.134 75 50 75H68C71.866 75 75 71.866 75 68V50C75 46.134 71.866 43 68 43H50ZM49 50C49 49.4477 49.4477 49 50 49H68C68.5523 49 69 49.4477 69 50V68C69 68.5523 68.5523 69 68 69H50C49.4477 69 49 68.5523 49 68V50Z",
    fill: "#618DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawer);
export default __webpack_public_path__ + "static/media/icon-drawer.b80f42ea95246465e79ec90a27258112.svg";
export { ForwardRef as ReactComponent };